'use strict';
rcElementsSelectAndSort.$inject = ['$q', 'accountService', 'accountStructureService', 'ACCOUNT_TYPES'];
angular.module('schoolLinqApp').directive('rcElementsSelectAndSort', rcElementsSelectAndSort);

function rcElementsSelectAndSort($q, accountService, accountStructureService, ACCOUNT_TYPES) {
	return {
		require: ['ngModel'],
		scope: {
			ngModel: '=',
			heading: '=',
		},
		replace: true,
		restrict: 'AE',
		template: require('@ajs/templates/reports/rcElementsSelectAndSort.html'),
		controller: [
			'$scope',
			'$element',
			'$rootScope',
			function ($scope, $element, $rootScope) {
				$scope.eRows = $scope.ngModel;
				$scope.elements = [];

				loadAccountTypes();

				function loadAccountTypes() {
					return accountStructureService.getAccountTypes().then(finishLoadingAccountTypes);
					function finishLoadingAccountTypes(response) {
						$scope.accountTypes = response.data.accountTypes;

						$scope.accountTypes = _.filter(response.data.accountTypes, function (accntType) {
							let retTypes = accntType.Id === ACCOUNT_TYPES.Expense || accntType.Id === ACCOUNT_TYPES.Revenue;
							if ($rootScope.mode === 'sa') {
								retTypes = retTypes || accntType.Id === ACCOUNT_TYPES.Net;
							}
							return retTypes;
						});

						let elementNameList = [];

						for (let idx = 0; idx < $scope.accountTypes.length; idx++) {
							let accntType = $scope.accountTypes[idx];
							let elements = accntType.ElementMap.split('.');
							let masks = accntType.Mask.split('.');

							for (let i = 0; i < elements.length; i++) {
								let elementName = elements[i].toString();
								let elementItem = _.find($scope.elements, function (obj) {
									return obj.Id === elementName;
								});
								if (!elementItem) {
									elementNameList.push(elementName);

									$scope.elements.push({
										Index: $scope.elements.length,
										Id: elementName,
										Description: elementName,
									});
								}
							}
						}
					}
				}

				angular.extend($scope, {
					addRow: function () {
						$scope.eRows.push({ ElementName: '' });
					},
					moveUp: function (row) {
						let index = _.findIndex($scope.eRows, { $$hashKey: row.$$hashKey });
						// get the row to move down
						var rowToMoveDown = $scope.eRows[index - 1];
						$scope.eRows.splice(index - 1, 1);
						$scope.eRows.splice(index, 0, rowToMoveDown);
					},
					moveDown: function (row) {
						let index = _.findIndex($scope.eRows, { $$hashKey: row.$$hashKey });
						// get the row to move up
						var rowToMoveUp = $scope.eRows[index + 1];
						$scope.eRows.splice(index + 1, 1);
						$scope.eRows.splice(index, 0, rowToMoveUp);
					},
					removeRow: function (row) {
						let index = _.findIndex($scope.eRows, { $$hashKey: row.$$hashKey });
						$scope.eRows.splice(index, 1);
					},

					elementChange: function (row) {
						//Prevent Duplicates
						var counts = _.countBy($scope.eRows, function (r) {
							return r.ElementName === row.ElementName && row.ElementName.length > 0;
						});
						if (counts.true > 1) {
							row.ElementName = '';
						}
					},
				});
			},
		],
	};
}
